import * as types from '../actions/actionTypes';

const initialState = {
  data: [],
  leftPanel: {
    building: {
      city: 'London'
    }
  },
  weather: {},
  isDay: 1,
  isShowMenu: false
};

const widgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_WIDGETS_SUCCESS:
      return Object.assign({}, state, {
        data: action.info.data,
        leftPanel: action.info.left_panel,
        whiteLabel: action.info.whitelabel,
      });
    case types.LOAD_WEATHER_SUCCESS:
      return Object.assign({}, state, {
        weather: action.info,
        isDay: action.info.current.is_day === 'yes' ? 1 : 0
      });
    case types.TOGGLE_MOBILE:
      return Object.assign({}, state, {
        isShowMenu: !state.isShowMenu
      });
    default:
      return state;
  }
};

export default widgetReducer;
